import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { useAuth, formatErr } from "../context/AuthContext";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { Loader2, Euro } from "lucide-react";

const CATS = ["elettricista", "idraulico", "frigorista"];
const SUBS = ["apprendista", "operaio", "tecnico"];

export default function AdminHourlyRates() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [rates, setRates] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user?.role !== "admin") navigate("/login");
  }, [user, loading, navigate]);

  const load = async () => {
    try {
      const r = await api.get("/hourly-rates");
      const map = {};
      r.data.forEach(x => { map[`${x.category}_${x.subcategory}`] = x.hourly_rate; });
      setRates(map);
    } catch { /* ignore */ }
  };
  useEffect(() => { if (user) load(); }, [user]);

  const save = async (cat, sub) => {
    const key = `${cat}_${sub}`;
    const v = parseFloat(rates[key]);
    if (isNaN(v) || v < 0) return toast.error("Valore non valido");
    setBusy(true);
    try {
      await api.put("/hourly-rates", { category: cat, subcategory: sub, hourly_rate: v });
      toast.success(`Tariffa ${cat} ${sub} aggiornata`);
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };

  if (!user || user.role !== "admin") return <div className="min-h-screen"><Navbar/></div>;

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar/>
      <div className="max-w-4xl mx-auto p-6">
        <div className="mt-6 mb-6">
          <div className="text-xs uppercase tracking-widest text-blue-800 font-semibold">Amministrazione</div>
          <h1 className="heading text-3xl md:text-4xl font-extrabold text-slate-900 flex items-center gap-2"><Euro className="w-7 h-7"/>Tariffe orarie</h1>
          <p className="text-sm text-slate-600 mt-1">Costo €/ora per categoria e sottocategoria degli operai</p>
        </div>
        <Card className="p-6" data-testid="rates-grid">
          <div className="grid grid-cols-4 gap-3 items-center font-semibold text-xs uppercase tracking-widest text-slate-500 pb-3 border-b">
            <div/>{SUBS.map(s => <div key={s} className="text-center">{s}</div>)}
          </div>
          {CATS.map(cat => (
            <div key={cat} className="grid grid-cols-4 gap-3 items-center py-3 border-b">
              <div className="font-medium capitalize text-slate-900">{cat}</div>
              {SUBS.map(sub => {
                const k = `${cat}_${sub}`;
                return (
                  <div key={sub} className="flex gap-1">
                    <div className="relative flex-1">
                      <Input type="number" min="0" step="0.5" value={rates[k] ?? ""} onChange={e=>setRates({...rates,[k]:e.target.value})}
                             className="pr-8" data-testid={`rate-${cat}-${sub}`}/>
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-500">€/h</span>
                    </div>
                    <Button size="sm" variant="outline" onClick={()=>save(cat,sub)} disabled={busy} data-testid={`rate-save-${cat}-${sub}`}>OK</Button>
                  </div>
                );
              })}
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
